
import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { breadcrumbItem } from 'src/app/components/breadcrumbs/breadcrumbs.model';
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api';
import { HttpClient } from '@angular/common/http';
import { setLoadingSpinner } from 'src/app/store/sharedstate/shared.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { AlertService } from 'src/app/core/services/AlertService/alert.service';
import { PermissionService } from 'src/app/core/services/permission.service';



@Component({
  selector: "app-network-summery",
  templateUrl: "./network-summery.component.html",
  styleUrls: ["./network-summery.component.scss"],
})


export class NetwokSummeryComponent {
  breadcrumbItems: breadcrumbItem[] = [
    {
      label: "Home",
      active: false,
      url: "/home",
    },
    {
      label: "Employees",
      active: false,
      url: "/employees/jobtypes/employee-stup-home",
      // url:"/employees/jobtypes"
    },
    {
      label: "Site Network",
      active: true,
      url: "",
    },
  ];

  GLOBALURL: any;
  headerToken = { 'Content-Type': 'application/json', 'Authorization': this.cookieService.get('token') };
  httpOptions = { headers: new HttpHeaders(this.headerToken) };

  hosts: any = [];
  sites: any = [];

  constructor(
    private router: Router,
    private BreadcrumbService: BreadcrumbService,
    private cookieService: CookieService,
    private ApiService: ApiService,
    private http: HttpClient,
    private store: Store<AppState>,
    private toastr: AlertService,
    public permissionService: PermissionService,

  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
  }

  ngOnInit() {
    if (!this.permissionService.canAccessSuper('Site Network', 1)) {
      this.toastr.error("You are not authorized to perform this operation.");
      this.router.navigate(['/overview']);
      return;
    }
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.BreadcrumbService.setValue(this.breadcrumbItems);

    this.getSitesList();
  }

  GotonetworkOverviewPage(hostId: any) {
    this.router.navigate(["/network-overview", hostId]);
  }

  getAllHosts() {

    this.http.get(this.GLOBALURL + "/ubiquiti/host", this.httpOptions)
      .subscribe((response: any) => {
        this.hosts = response.data;

        this.hosts.forEach((host: any) => {
          let foundObject = this.sites.find((site: any) => site.hostId == host?.id);

          if (foundObject) {
            host.ispInfo = foundObject.statistics.ispInfo;
          }
        });

        this.store.dispatch(setLoadingSpinner({ status: false }));
      },
      (error) => {
        console.error("Error getting hosts: ", error);
        this.store.dispatch(setLoadingSpinner({ status: false }));
        this.toastr.error("Error getting hosts.")
      })
  }

  getSitesList() {
    this.http.get(this.GLOBALURL + "/ubiquiti/sites", this.httpOptions)
      .subscribe((response: any) => {
        this.sites = response.data;
        this.getAllHosts();
      },
      (error) => {

      });
  }
}




